// firebaseConfig.ts  – browser side
import { initializeApp, type FirebaseOptions } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAuth, type Auth } from "firebase/auth";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
  type RemoteConfig,
} from "firebase/remote-config";

const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_API_KEY || "",
  authDomain: "auth.stomployalty.com",
  projectId: process.env.REACT_APP_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_storage_bucket || "",
  messagingSenderId: process.env.REACT_APP_messaging_sender_id || "",
  appId: process.env.REACT_APP_app_id || "",
  measurementId: process.env.REACT_APP_measurement_id || "",
};

const app = initializeApp(firebaseConfig);

/* ------------ core services ------------ */
const db = getFirestore(app);
const storageRef = getStorage(app);
const functions = getFunctions(app);
const auth: Auth = getAuth(app);

/* ------------ Remote Config ------------ */
const rc: RemoteConfig = getRemoteConfig(app);
rc.settings.minimumFetchIntervalMillis = 60 * 60 * 1000;
rc.defaultConfig = {
  api_url: "https://stomp-functions-xyz.cloudfunctions.net",
};

export async function loadRemoteConfig() {
  try {
    await fetchAndActivate(rc);
  } catch (err) {
    console.warn("[RC] fetch failed - using defaults", err);
  }
}

/** Cloud-Run base URL for API calls */
export function apiBase(): string {
  return getValue(rc, "api_url").asString();
}

/* ------------ re-exports ------------ */
export { app, db, storageRef, auth, functions };
